import { cn } from '@/lib/cn'
import styles from './Avatar.module.css'

const initialsOf = (name: string): string =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')

export function Avatar({
  name,
  src,
  size = 36,
  className,
}: {
  readonly name: string
  readonly src?: string | undefined
  readonly size?: number | undefined
  readonly className?: string | undefined
}) {
  return (
    <span
      className={cn(styles.avatar, className)}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
    >
      {src ? <img className={styles.image} src={src} alt="" /> : initialsOf(name)}
    </span>
  )
}
